<template>
  <div class="catg-listing-area">
    <div class="catg-listing">
    <div class="chart-detail-title d-sm-flex justify-content-between">
      <h2>職種別登録者状況</h2>
    </div><!-- ends chart-detail-title -->
      <div class="row">
        <category-item v-if="categories.length"
        v-for="category in categories" :category="category"
        :key="category.title" />
<!--        v-on:click="categoryClicked(category)"/>-->
      </div>
    </div><!-- ends catg-listing -->
  </div>
</template>
<script>
import CategoryItem from '@/components/dashboard/category/NewCategoryItem.vue';
import actions from '@/config/actions';
import mutations from '@/config/mutations';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  name: 'NewCategoryList',
  components: { CategoryItem },
  data() {
    return {
      showAll: false,
      toggleClass: 'hide',
    };
  },
  created() {
    const { path } = this.$route;
    const params = {};
    if (path.indexOf('dashboard') > -1) params.page = 'dashboard';
    this.load(params);
  },
  computed: {
    ...mapState({
      categories: ({ applicant }) => applicant.categories,
      occupations: ({ applicant }) => applicant.selectors.occupations || [],
    }),
    reversedCategories() {
      const newCategories = this.categories;
      return newCategories.reverse();
    },
  },
  methods: {
    ...mapActions([
      actions.applicant.LOAD_CATEGORIES,
      actions.applicant.LOAD_SELECTORS,
    ]),
    ...mapMutations([
      mutations.applicant.SET_CATEGORIES,
      // mutations.applicant.CHANGE_SEARCH_PARAMS,
      mutations.applicant.SET_SELECTORS,
      'setMainJobModel',
    ]),
    load(path) {
      this[actions.applicant.LOAD_CATEGORIES](path)
        .then(({ data }) => {
          this[mutations.applicant.SET_CATEGORIES](data.data);
        })
        .catch(({ response }) => {
          this.parseErrorResponse(response);
        });
      this[actions.applicant.LOAD_SELECTORS]()
        .then(({ data }) => {
          this[mutations.applicant.SET_SELECTORS](data.data);
        })
        .catch(({ response }) => this.parseErrorResponse(response));
    },
    /*categoryClicked(category) {
      // // console.log(this.occupations);
      // const subOccupations = [];
      // // const params = {};
      // const main = this.occupations.find(occupation => category.id === occupation.id);
      // // eslint-disable-next-line
      // main.children.forEach(child => subOccupations.push(child._id));
      this.setMainJobModel([category.id]);
      // params.childOccupations = subOccupations;
      // this[mutations.applicant.CHANGE_SEARCH_PARAMS](params);
      this.$router.push({ name: 'applicant' });
    },*/
  },
};
</script>

<style scoped>
</style>
